import MessengerModal from "./messengerModal";
import React from "react";
import {Row} from "reactstrap";
import Col from "reactstrap/es/Col";
import ActionsModalFooter from "./actionsModalFooter";
import {useDispatch, useSelector} from "react-redux";
import {fireComplain, fireRestore} from "../../actions/humanTaskActions";
import {isSuspended} from "../stripe/utils/actionStripeConfig";
import {generateFormatDate} from "../../core/utils";

export const ActionsRestoreModal = ({isOpen, onToggle}) => {

    const complaining = useSelector(state => state?.humanTask?.complaining);
    const ht = useSelector(state => state?.humanTask?.humanTask);
    const cidla = useSelector(state => state?.messenger?.cidla);

    const dispatch = useDispatch();

    const conversationSuspended = isSuspended(ht);

    const handlePrimary = () => {
        dispatch(fireComplain(cidla)).then(() => onToggle())
    };

    const bodyText = () => {
        return conversationSuspended ?
            `Chystáte se obnovit odloženou konverzaci. Opravdu chcete pokračovat v této konverzaci před ${generateFormatDate(ht.suspendedUntil, "DD.MM.YYYY HH:mm")} ?` :
            'Chystáte se obnovit ukončenou konverzaci. Opravdu chcete s klientem pokračovat v této konverzaci? Pro založení nové konverzace na jiné téma zvolte možnost Založit novou konverzaci.';
    }

    const labelText =
         conversationSuspended ?
            'Obnovit odloženou konverzaci' :
            'Obnovit konverzaci';

    const getBody = () => {
        return (
            <>
                <Row>
                    <Col>
                        {bodyText()}
                    </Col>
                </Row>
            </>
        )
    };

    const doRestore = () => {
        dispatch(fireRestore());
    };

    const getFooter = () => {
        const primary = {
            onClick: handlePrimary,
            text: 'Obnovit tuto konverzaci'
        };

        const secondary = conversationSuspended ? null :{
            onClick: () => doRestore(),
            text: 'Založit novou konverzaci'
        };

        const cancel = {
            text: 'Zpět na přehled',
            onClick: onToggle
        };

        return (
            <ActionsModalFooter primary={primary} cancel={cancel} secondary={secondary}/>
        )
    };

    return (
        <MessengerModal
            size="xs"
            error={complaining.error}
            processing={complaining.progress}
            processingText="Obnovuji konverzaci"
            isOpen={isOpen}
            onToggle={onToggle}
            header={labelText}
            body={getBody()}
            footer={getFooter()}
        />
    )
};

export default ActionsRestoreModal